var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 내 오픈 마켓 리스트 레이아웃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }